const MAX_HEAT = 100;
const HEAT_PER_DISCARD = 30;
const HEAT_PER_DISCARD_TIME_ATTACK = 20;
const COOL_PER_PLACEMENT = 8;
const COOL_PER_CLEAR = 15;
const BASE_FILL_RATE = 5;

export class DroughtGauge {
  private heat: number;
  private timeAttack: boolean;
  private fillRate: number;

  constructor(heat?: number, timeAttack?: boolean, level?: number) {
    this.heat = heat ?? 0;
    this.timeAttack = timeAttack ?? false;
    const repeat = level ? Math.floor((level - 1) / 25) : 0;
    this.fillRate = BASE_FILL_RATE + repeat;
  }

  getHeat(): number {
    return this.heat;
  }

  getMax(): number {
    return MAX_HEAT;
  }

  getPercent(): number {
    return this.heat / MAX_HEAT;
  }

  addDiscard(): void {
    const amount = this.timeAttack ? HEAT_PER_DISCARD_TIME_ATTACK : HEAT_PER_DISCARD;
    this.heat = Math.min(MAX_HEAT, this.heat + amount);
  }

  coolOnPlacement(): void {
    this.heat = Math.max(0, this.heat - COOL_PER_PLACEMENT);
  }

  coolOnClear(lineCount: number): void {
    this.heat = Math.max(0, this.heat - COOL_PER_CLEAR * lineCount);
  }

  addPassiveHeat(deltaSeconds: number): void {
    if (!this.timeAttack) return;
    this.heat = Math.min(MAX_HEAT, this.heat + this.fillRate * deltaSeconds);
  }

  reset(): void {
    this.heat = 0;
  }

  isFull(): boolean {
    return this.heat >= MAX_HEAT;
  }

  isTimeAttack(): boolean {
    return this.timeAttack;
  }
}
